import { Status } from './status';
import { Issue } from './issue';

export class Column {

  public name: string;
  public statuses: Status[];

  constructor(name: string, statuses: Status[]) {
    this.name = name;
    this.statuses = statuses;
  }

  /**
     * Used to determine the type of column independent of the (customizable) column-name.
     * We assume that all statuses of this column have the same StatusCategory-Key.
     */
  getStatusCategoryKey() {
    if (this.statuses.length > 0) {
      return this.statuses[0].statusCategory.key;
    } else {
      return '';
    }
  }

  /**
     * Returns true if this column should support adding new issues.
     * Current implementation: They column must have a status of the statuscategory with key 'new'. This
     * refers to 'TO DO'-Status
     */
  supportsAddingIssues() {
    return this.getStatusCategoryKey() === 'new';
  }

  /**
     * Checks if the issue has a status that matches one of the statuses of this column.
     * Used to place the issue in the correct column.
     */
  statusMatchesIssue(issue: Issue): boolean {
    return this.statuses.some(status => (Number(issue.status.id) === Number(status.id)));
  }

  /**
     * Used as class-string in the template. Method should probably be moved to utility class
     */
  getStatusesIds(): number[] {
    const statusesIds: number [] = [];
    this.statuses.forEach(status => {
      statusesIds.push(status.id);
    });
    return statusesIds;
  }
}
